 import React, { useEffect,useState } from 'react';
 import UseForm from './UseForm';
 import '../Bootstrap/bootstrap.min.css';
 import './EmployeeForm.css';
 import * as Services from '../../Context/Services';
 const EmployeeForm =(props)=>{
    const errorStyle = {
        color: 'red'
        ,fontSize: '14px'
      ,fontFamily:'Roboto'      
      };
      const serverError = {
        color: 'red'
        ,fontSize: '18px'
      ,fontFamily:'Roboto'      
      };
    const [choicesObj, setChoicesObj] =useState({});
    const [showModal,setShowModal] = useState(false);
  //const [isSucc,setIsSucc] = useState(true);
  const [isSucc,setIsSucc] = useState(null);
  const [companyChoicesOpt, setCompanyChoicesOpt] =useState([]);
  const [firstName,setFirstName]= useState('');
const [sendMessage,setSendMessage] =useState(false);
    const constNewsLetterObj={ Fields:{
        Content: { value: '',error:'' }
        ,PrefixPhoneNumber: { value: '',error:'' }
        ,PhoneNumber: { value: '',error:'' }
        //,ContactUsChoice: { value: '', error:''}
        ,FirstName: { value: '', error:''}
        ,LastName: { value: '', error:''}      
          ,Email: { value: '', error:''}
        ,Region: { value: '', error:''}
        ,Degree: { value: '', error:''}
        ,Service: { value: '', error:''}
        ,Exprience: { value: '', error:''}
    },
    MailTo:'',
    //the key in webconfig
    type: 1
    , webUrl: props.mainURL
    };
    let validationStateSchema = {
        //Title: { },
        Region: { required: true,}
        ,Degree: { required: true,}
        ,Service: { required: true,}
        ,Exprience: { required: true}
        ,Content:{},
        FirstName: {
          required: true,
          validator: {
            regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
            error: 'שם לא תקין',
          },
        },
        LastName: {
            required: true,
            validator: {
              regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
              error: 'שם לא תקין',
            },
          },
          PhoneNumber: {
          required: true,
          validator: {
            regEx:/^\d+$/,
            error: 'מספר לא תקין',
          },
         },
         PrefixPhoneNumber:{  required: true},
        Email: {    
          required: true,
            validator: {
              regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              error: 'מייל לא תקין.',
            },
          },
    
      };
      const onSubmitForm=(state)=>{
     
              if(!sendMessage){
                setSendMessage(true);
                let dataObj ={};
     
              Object.keys(state['Fields']).map((subKey,index)=>{
                dataObj[subKey]=state['Fields'][subKey].value;
              });
     
         
            Services.SendEmployeeForm(dataObj).then(response=>{
              
              setIsSucc(true);
            })
                  .catch((error)=>{
                    setIsSucc(false);
              
                    console.error(error);
                  });
                }
         
      };
    
        
    const { state, handleOnChange, handleOnSubmit, disable } = UseForm(constNewsLetterObj,validationStateSchema,onSubmitForm  );


       return (<div className="container-contactus-wrapper col-12 col-md-11 ">
  
        <h2 className="contactus-title">{props.title}</h2>
       
        {props.showNote &&   <div className="col-12 col-md-12 row">
                              <div className="col-12 col-md-12">
    <div className="contactus-note  col-12 col-md-12" >
            <div className="info-icons col-2 col-md-1"></div>
          <div className="contactus-info-note col-10 col-md-12">
                <h3 className="contactus-note-title">Please note</h3>
                <h3 className="contactus-note-text col-md-11">{props.freeText}</h3>
            </div>
    </div></div></div>}
  
    <div className="container-employee-form-wrapper" >
              
              <form             
                   onSubmit={handleOnSubmit}   
              >
              <div className="container-newsletter-wrapper-child col-12 col-md-12">
              <div className="newslettertitle-input-warpper  col-12 col-md-12 row">
                  <div className="newsletter-form-field newsletter-checkbox-title col-12 col-sm-6 col-md-6 form-group">
                            <label className="col-12 col-md-12" htmlFor={'first-name-news-letter'}>שם פרטי</label>
                            <input
                             type='text'
                             maxLength="126"
                             onChange={handleOnChange} 
                             value={state.Fields["FirstName"].value}
                             name='FirstName'
                             className="col-12 col-md-12"
                             required
                              id={'FirstName'}  placeholder="שדה חובה"/>
                            {state.Fields["FirstName"].error && <p style={errorStyle}>{state.Fields["FirstName"].error}</p>}
                        
                  </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-sm-6 col-md-6 form-group">
                                    <label className="col-12 col-md-12" htmlFor={'last-name-news-letter'}>שם משפחה</label>
                                    <input className="col-12 col-md-12"  type='text'  id={'last-name-news-letter'} 
                                    placeholder="שדה חובה" 
                                    value={state.Fields["LastName"].value}
                                    onChange={handleOnChange}  name='LastName'
                                    required
                                    maxLength="126"/>
                                    {state.Fields["LastName"].error && <p style={errorStyle}>{state.Fields["LastName"].error}</p>}
                                                            </div>
                                                            <div className="newsletter-form-field newsletter-checkbox-title col-12  col-sm-6 col-md-6 form-group">
                                    <label className="col-12 col-md-12" htmlFor={'company-news-letter'}>אזור מגורים</label>
                                    <select className="col-12 col-md-12" id={'company-news-letter'} required
                                            onChange={handleOnChange}
                                            name='Region'
                                            value={state.Fields["Region"].value}
                                            id='Region' >
                                        <option value="" disabled  hidden  >בחר</option>
                                        <option value="דרום"   >דרום</option>
                                        <option value="ירושלים והסביבה" >ירושלים והסביבה</option>
                                        <option value="מרכז"  >מרכז</option>
                                        <option value="צפון"  >צפון</option>
                                        <option value="שרון"   >שרון</option>
                                        <option value="שפלה" >שפלה</option>
                                        
                                        {/* {companyChoicesOpt} */}
                                    </select>
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12  col-sm-6  col-md-6 form-group">                           
                                    <label className="col-12 col-md-12" htmlFor={'mail-news-letter'}>מייל</label>
                                    <input className="col-12 col-md-12"  type='text'  id={'mail-news-letter'} placeholder="שדה חובה"
                                    onChange={handleOnChange}  name='Email'
                                    value={state.Fields["Email"].value}
                                    maxLength="126" required
                                    />

                                    {state.Fields["Email"].error && <p style={errorStyle}>{state.Fields["Email"].error}</p>}                        </div>
                        <div className="phone-form-field newsletter-checkbox-title col-12  col-sm-6  col-md-6 form-group">
                                   
                                    <label className="col-6 col-md-7" for="phone-news-letter">טלפון</label>
                                    <label className="col-5 col-md-4" for="company-news-letter">קידומת</label>
                                    <div className='input-phone-warpper'>
                                    <select className="col-5 col-md-4" id={'company-news-letter'} required
                                            onChange={handleOnChange}
                                            name='PrefixPhoneNumber'
                                            value={state.Fields["PrefixPhoneNumber"].value}
                                            id='PrefixPhoneNumber' >
                                        <option value="" disabled  hidden  >קידומת</option>
                                        <option value="02"  >02</option>
                                        <option value="03"   >03</option>
                                        <option value="04" >04</option>
                                        <option value="08" >08</option>
                                        <option value="09" >09</option>

                                        <option value="050"  >050</option>
                                        <option value="051"   >051</option>
                                        <option value="052" >052</option>
                                        <option value="053" >053</option>
                                        <option value="054" >054</option>

                                        <option value="055"  >055</option>
                                     
                                        <option value="057" >057</option>
                                        <option value="058" >058</option>
                                    
                                        <option value="072" >072</option>
                                        <option value="073" >073</option>
                                        {/* {companyChoicesOpt} */}
                                    </select>
                                    <div className="col-1 col-md-1"></div>
                                    <input className="col-6 col-md-7"  type='text'  id={'phone-news-letter'}  placeholder="שדה חובה"
                                    onChange={handleOnChange}  name='PhoneNumber'
                                    value={state.Fields["PhoneNumber"].value}
                                            maxLength="7" required
                                    />
                                    </div>
                                    {state.Fields["PhoneNumber"].error && <p style={errorStyle}>{state.Fields["PhoneNumber"].error}</p>}
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12  col-sm-6  col-md-6 form-group">
                                    <label className="col-12 col-md-12" htmlFor={'company-news-letter'}>השכלה</label>
                                    <select className="col-12 col-md-12" id={'company-news-letter'} required
                                            onChange={handleOnChange}
                                            name='Degree'
                                            value={state.Fields["Degree"].value}
                                            id='Degree' >
                                        <option value="" disabled  hidden  >בחר השכלה</option>   
                                        <option value="תיכונית"   >תיכונית</option>   
                                        <option value="סטודנט במהלך התואר" >סטודנט במהלך התואר</option>   
                                        <option value="תואר ראשון"   >תואר ראשון</option>   
                                        <option value="תואר שני ומעלה"   >תואר שני ומעלה</option>   
                                    </select>
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-sm-6  col-md-6 form-group">
                                    <label className="col-12 col-md-12" htmlFor={'company-news-letter'}>שירות צבאי</label>
                                    <select className="col-12 col-md-12" id={'company-news-letter'} required
                                            onChange={handleOnChange}
                                            name='Service'
                                            value={state.Fields["Service"].value}
                                            id='Service' >
                                        <option value="" disabled  hidden  >בחר שירות צבאי</option>   
                                        <option value="שירות סדיר"   >שירות סדיר</option>   
                                        <option value="שירות קבע" >שירות קבע</option>   
                                        <option value="שירות לאומי"   >שירות לאומי</option>   
                                        <option value="פטור משירות"   >פטור משירות</option>   
                                    </select>
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12  col-sm-6 col-md-6 form-group">
                                    <label className="col-12 col-md-12" htmlFor={'company-news-letter'}>נסיון תעסוקתי</label>
                                    <select className="col-12 col-md-12" id={'company-news-letter'} required
                                            onChange={handleOnChange}
                                            name='Exprience'
                                            value={state.Fields["Exprience"].value}
                                            id='Exprience' >
                                        <option value="" disabled  hidden  >בחר ניסיון תעסוקתי</option>   
                                        <option value="רכש"   >רכש</option>   
                                        <option value="לוגיסטיקה ושינוע" >לוגיסטיקה ושינוע</option>   
                                        <option value="כלכלה"   >כלכלה</option>   
                                        
                                    </select>
                        </div>
                         <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-12">
                                    <label className="col-12 col-md-12" htmlFor={'last-name-news-letter'}>הערות</label>
                                    <textarea className="col-12 col-md-12"  rows="4" maxLength="512"   id={'last-name-news-letter'} 
                                    placeholder="Message" 
                                    value={state.Fields["Content"].value}
                                    onChange={handleOnChange}  name='Content'
                                    />
                                  
                                      </div> 
                  </div>
                  
                
                
              <button  className='btn btn-primary newsletter-btn' type="submit" name="submit" disabled={sendMessage}>שלח</button>
              {isSucc && <h4 >בקשתך נשלחה בהצלחה</h4>}
                                    {isSucc===false && <h4 style={serverError}>התקבלה שגיאה. אנא נסה לשלוח מאוחר יותר</h4>}
              </div>
              </form> 
          </div>
    </div>);
 }

 export default EmployeeForm;